module.exports = __webpack_public_path__ + "static/media/vip-message-background.a9fd6cb7.png";